import { MainCategory, SubCategory } from '@flows.cash/types'

export const defaultCategories: MainCategory[] = [
  {
    id: 'housing',
    name: 'Housing',
    type: 'expense',
    color: '#E53935',
    icon: 'Home',
    isExpanded: false,
    description: 'Essential housing-related expenses including rent, mortgage, maintenance, and home insurance',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'rent',
        name: 'Rent/Mortgage',
        type: 'expense',
        color: '#E53935',
        parentId: 'housing',
        icon: 'Key',
        transactionCount: 0,
        description: 'Monthly rent payments or mortgage installments',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'property_tax',
        name: 'Property Tax',
        type: 'expense',
        color: '#E53935',
        parentId: 'housing',
        icon: 'FileText',
        transactionCount: 0,
        description: 'Annual or periodic property tax payments',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'maintenance',
        name: 'Maintenance',
        type: 'expense',
        color: '#E53935',
        parentId: 'housing',
        icon: 'Hammer',
        transactionCount: 0,
        description: 'Home repairs, maintenance, and improvement costs',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'home_insurance',
        name: 'Home Insurance',
        type: 'expense',
        color: '#E53935',
        parentId: 'housing',
        icon: 'ShieldCheck',
        transactionCount: 0,
        description: 'Home or renter\'s insurance premiums',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'furniture',
        name: 'Furniture',
        type: 'expense',
        color: '#E53935',
        parentId: 'housing',
        icon: 'Sofa',
        transactionCount: 0,
        description: 'Furniture purchases and home decor items',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'transportation',
    name: 'Transportation',
    type: 'expense',
    color: '#1E88E5',
    icon: 'Car',
    isExpanded: false,
    description: 'Vehicle and travel-related expenses including fuel, maintenance, insurance, and public transit',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'car_payment',
        name: 'Car Payment',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'CreditCard',
        transactionCount: 0,
        description: 'Monthly vehicle loan or lease payments',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'gas',
        name: 'Gas/Fuel',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'Fuel',
        transactionCount: 0,
        description: 'Vehicle fuel and gas station purchases',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'car_insurance',
        name: 'Car Insurance',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'ShieldCheck',
        transactionCount: 0,
        description: 'Vehicle insurance premiums',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'car_maintenance',
        name: 'Car Maintenance',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'Tool',
        transactionCount: 0,
        description: 'Vehicle repairs, maintenance, and servicing',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'public_transit',
        name: 'Public Transit',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'Train',
        transactionCount: 0,
        description: 'Public transportation fares and passes',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'parking',
        name: 'Parking',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'ParkingCircle',
        transactionCount: 0,
        description: 'Parking fees and permits',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'rideshare',
        name: 'Rideshare/Taxi',
        type: 'expense',
        color: '#1E88E5',
        parentId: 'transportation',
        icon: 'MapPin',
        transactionCount: 0,
        description: 'Uber, Lyft, taxi, and ride-sharing services',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'food',
    name: 'Food',
    type: 'expense',
    color: '#43A047',
    icon: 'Utensils',
    isExpanded: false,
    description: 'Food and dining expenses including groceries, restaurants, and meal delivery',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'groceries',
        name: 'Groceries',
        type: 'expense',
        color: '#43A047',
        parentId: 'food',
        icon: 'ShoppingCart',
        transactionCount: 0,
        description: 'Grocery shopping and food supplies',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'restaurants',
        name: 'Restaurants',
        type: 'expense',
        color: '#43A047',
        parentId: 'food',
        icon: 'Coffee',
        transactionCount: 0,
        description: 'Dining out at restaurants and cafes',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'fast_food',
        name: 'Fast Food',
        type: 'expense',
        color: '#43A047',
        parentId: 'food',
        icon: 'Pizza',
        transactionCount: 0,
        description: 'Quick service and fast food purchases',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'delivery',
        name: 'Food Delivery',
        type: 'expense',
        color: '#43A047',
        parentId: 'food',
        icon: 'Truck',
        transactionCount: 0,
        description: 'Food delivery and takeout orders',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'alcohol',
        name: 'Alcohol',
        type: 'expense',
        color: '#43A047',
        parentId: 'food',
        icon: 'Wine',
        transactionCount: 0,
        description: 'Alcoholic beverages and bar expenses',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'health',
    name: 'Health',
    type: 'expense',
    color: '#8E24AA',
    icon: 'Heart',
    isExpanded: false,
    description: 'Healthcare and wellness expenses including insurance, medical visits, and fitness',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'health_insurance',
        name: 'Health Insurance',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'ShieldCheck',
        transactionCount: 0,
        description: 'Health and medical insurance premiums',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'doctor',
        name: 'Doctor Visits',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'Stethoscope',
        transactionCount: 0,
        description: 'Medical appointments and healthcare visits',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'pharmacy',
        name: 'Pharmacy',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'Pill',
        transactionCount: 0,
        description: 'Prescription medications and pharmacy purchases',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'gym',
        name: 'Gym/Fitness',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'Dumbbell',
        transactionCount: 0,
        description: 'Gym memberships and fitness subscriptions',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'mental_health',
        name: 'Mental Health',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'Brain',
        transactionCount: 0,
        description: 'Mental health and therapy services',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'dental',
        name: 'Dental',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'Smile',
        transactionCount: 0,
        description: 'Dental care and orthodontic treatments',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'vision',
        name: 'Vision',
        type: 'expense',
        color: '#8E24AA',
        parentId: 'health',
        icon: 'Eye',
        transactionCount: 0,
        description: 'Eye care, glasses, and vision services',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'entertainment',
    name: 'Entertainment',
    type: 'expense',
    color: '#FB8C00',
    icon: 'Film',
    isExpanded: false,
    description: 'Entertainment and leisure activities including streaming, movies, concerts, and hobbies',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'streaming',
        name: 'Entertainment Streaming',
        type: 'expense',
        color: '#FB8C00',
        parentId: 'entertainment',
        icon: 'Tv',
        transactionCount: 0,
        description: 'Entertainment streaming services like Netflix, Disney+',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'movies',
        name: 'Movies/Theater',
        type: 'expense',
        color: '#FB8C00',
        parentId: 'entertainment',
        icon: 'Clapperboard',
        transactionCount: 0,
        description: 'Movie tickets, theater visits, and entertainment venues',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'concerts',
        name: 'Concerts/Events',
        type: 'expense',
        color: '#FB8C00',
        parentId: 'entertainment',
        icon: 'Music',
        transactionCount: 0,
        description: 'Concerts, live events, and entertainment shows',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'hobbies',
        name: 'Hobbies',
        type: 'expense',
        color: '#FB8C00',
        parentId: 'entertainment',
        icon: 'Palette',
        transactionCount: 0,
        description: 'Hobby supplies, crafts, and recreational activities',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'books',
        name: 'Books/Magazines',
        type: 'expense',
        color: '#FB8C00',
        parentId: 'entertainment',
        icon: 'BookOpen',
        transactionCount: 0,
        description: 'Books, magazines, and reading materials',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'games',
        name: 'Games',
        type: 'expense',
        color: '#FB8C00',
        parentId: 'entertainment',
        icon: 'Gamepad2',
        transactionCount: 0,
        description: 'Video games, board games, and gaming subscriptions',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'shopping',
    name: 'Shopping',
    type: 'expense',
    color: '#00ACC1',
    icon: 'ShoppingBag',
    isExpanded: false,
    description: 'Shopping expenses for clothing, electronics, gifts, and personal items',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'clothing',
        name: 'Clothing',
        type: 'expense',
        color: '#00ACC1',
        parentId: 'shopping',
        icon: 'Shirt',
        transactionCount: 0,
        description: 'Clothing, shoes, and fashion purchases',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'electronics',
        name: 'Electronics',
        type: 'expense',
        color: '#00ACC1',
        parentId: 'shopping',
        icon: 'Smartphone',
        transactionCount: 0,
        description: 'Electronics, gadgets, and technology purchases',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'gifts',
        name: 'Gifts',
        type: 'expense',
        color: '#00ACC1',
        parentId: 'shopping',
        icon: 'Gift',
        transactionCount: 0,
        description: 'Gifts purchased for others',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'household',
        name: 'Household Items',
        type: 'expense',
        color: '#00ACC1',
        parentId: 'shopping',
        icon: 'Home',
        transactionCount: 0,
        description: 'Household items, cleaning supplies, and home essentials',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'personal_care',
        name: 'Personal Care',
        type: 'expense',
        color: '#00ACC1',
        parentId: 'shopping',
        icon: 'Scissors',
        transactionCount: 0,
        description: 'Personal care items and grooming products',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'education',
    name: 'Education',
    type: 'expense',
    color: '#7CB342',
    icon: 'GraduationCap',
    isExpanded: false,
    description: 'Educational expenses including tuition, books, courses, and student loans',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'tuition',
        name: 'Tuition',
        type: 'expense',
        color: '#7CB342',
        parentId: 'education',
        icon: 'School',
        transactionCount: 0,
        description: 'Educational tuition and school fees',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'books_supplies',
        name: 'Books & Supplies',
        type: 'expense',
        color: '#7CB342',
        parentId: 'education',
        icon: 'BookOpen',
        transactionCount: 0,
        description: 'Educational books, supplies, and materials',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'student_loans',
        name: 'Student Loans',
        type: 'expense',
        color: '#7CB342',
        parentId: 'education',
        icon: 'FileText',
        transactionCount: 0,
        description: 'Student loan payments and educational debt',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'courses',
        name: 'Courses & Workshops',
        type: 'expense',
        color: '#7CB342',
        parentId: 'education',
        icon: 'Lightbulb',
        transactionCount: 0,
        description: 'Online courses, workshops, and skill development',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'bills',
    name: 'Bills & Utilities',
    type: 'expense',
    color: '#F4511E',
    icon: 'Receipt',
    isExpanded: false,
    description: 'Utility bills and recurring subscriptions for essential services',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'electricity',
        name: 'Electricity',
        type: 'expense',
        color: '#F4511E',
        parentId: 'bills',
        icon: 'Zap',
        transactionCount: 0,
        description: 'Electric utility bills and power costs',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'water',
        name: 'Water',
        type: 'expense',
        color: '#F4511E',
        parentId: 'bills',
        icon: 'Droplet',
        transactionCount: 0,
        description: 'Water and sewer utility bills',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'internet',
        name: 'Internet',
        type: 'expense',
        color: '#F4511E',
        parentId: 'bills',
        icon: 'Wifi',
        transactionCount: 0,
        description: 'Internet service provider bills',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'phone',
        name: 'Phone',
        type: 'expense',
        color: '#F4511E',
        parentId: 'bills',
        icon: 'Phone',
        transactionCount: 0,
        description: 'Mobile phone and landline service bills',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'streaming_bills',
        name: 'Streaming Subscriptions',
        type: 'expense',
        color: '#F4511E',
        parentId: 'bills',
        icon: 'Tv',
        transactionCount: 0,
        description: 'Streaming subscriptions treated as utility bills',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'subscriptions',
        name: 'Subscriptions',
        type: 'expense',
        color: '#F4511E',
        parentId: 'bills',
        icon: 'Repeat',
        transactionCount: 0,
        description: 'Various subscription services and memberships',
        trackInNetWorth: true,
        isRecurring: true
      }
    ]
  },
  {
    id: 'travel',
    name: 'Travel',
    type: 'expense',
    color: '#5E35B1',
    icon: 'Plane',
    isExpanded: false,
    description: 'Travel and vacation expenses including flights, hotels, and vacation activities',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'flights',
        name: 'Flights',
        type: 'expense',
        color: '#5E35B1',
        parentId: 'travel',
        icon: 'Plane',
        transactionCount: 0,
        description: 'Airline tickets and flight bookings',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'hotels',
        name: 'Hotels',
        type: 'expense',
        color: '#5E35B1',
        parentId: 'travel',
        icon: 'Bed',
        transactionCount: 0,
        description: 'Hotel stays and accommodation bookings',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'car_rental',
        name: 'Car Rental',
        type: 'expense',
        color: '#5E35B1',
        parentId: 'travel',
        icon: 'Car',
        transactionCount: 0,
        description: 'Car rental services for travel',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'vacation',
        name: 'Vacation',
        type: 'expense',
        color: '#5E35B1',
        parentId: 'travel',
        icon: 'PalmTree',
        transactionCount: 0,
        description: 'Vacation packages and travel activities',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'travel_food',
        name: 'Food & Dining',
        type: 'expense',
        color: '#5E35B1',
        parentId: 'travel',
        icon: 'Utensils',
        transactionCount: 0,
        description: 'Food and dining expenses while traveling',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'souvenirs',
        name: 'Souvenirs',
        type: 'expense',
        color: '#5E35B1',
        parentId: 'travel',
        icon: 'ShoppingBag',
        transactionCount: 0,
        description: 'Travel souvenirs and vacation shopping',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'personal',
    name: 'Personal Care',
    type: 'expense',
    color: '#D81B60',
    icon: 'Smile',
    isExpanded: false,
    description: 'Personal care and beauty expenses including hair, skincare, and spa services',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'haircare',
        name: 'Hair Care',
        type: 'expense',
        color: '#D81B60',
        parentId: 'personal',
        icon: 'Scissors',
        transactionCount: 0,
        description: 'Hair salon services, cuts, and styling',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'skincare',
        name: 'Skin Care',
        type: 'expense',
        color: '#D81B60',
        parentId: 'personal',
        icon: 'Droplet',
        transactionCount: 0,
        description: 'Skincare products and treatments',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'cosmetics',
        name: 'Cosmetics',
        type: 'expense',
        color: '#D81B60',
        parentId: 'personal',
        icon: 'Brush',
        transactionCount: 0,
        description: 'Makeup and cosmetic products',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'spa',
        name: 'Spa & Massage',
        type: 'expense',
        color: '#D81B60',
        parentId: 'personal',
        icon: 'Sparkles',
        transactionCount: 0,
        description: 'Spa services, massages, and wellness treatments',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'financial',
    name: 'Financial',
    type: 'expense',
    color: '#9C27B0',
    icon: 'DollarSign',
    isExpanded: false,
    description: 'Financial services and fees including bank charges, taxes, and advisor fees',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'bank_fees',
        name: 'Bank Fees',
        type: 'expense',
        color: '#9C27B0',
        parentId: 'financial',
        icon: 'Building2',
        transactionCount: 0,
        description: 'Bank account fees and financial service charges',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'interest',
        name: 'Interest',
        type: 'expense',
        color: '#9C27B0',
        parentId: 'financial',
        icon: 'Percent',
        transactionCount: 0,
        description: 'Interest payments on loans and credit',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'taxes',
        name: 'Taxes',
        type: 'expense',
        color: '#9C27B0',
        parentId: 'financial',
        icon: 'FileText',
        transactionCount: 0,
        description: 'Tax payments and filing fees',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'insurance',
        name: 'Insurance',
        type: 'expense',
        color: '#9C27B0',
        parentId: 'financial',
        icon: 'ShieldCheck',
        transactionCount: 0,
        description: 'Various insurance premiums and coverage',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'financial_advisor',
        name: 'Financial Advisor',
        type: 'expense',
        color: '#9C27B0',
        parentId: 'financial',
        icon: 'BookOpen',
        transactionCount: 0,
        description: 'Financial planning and advisory services',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'legal',
        name: 'Legal Fees',
        type: 'expense',
        color: '#9C27B0',
        parentId: 'financial',
        icon: 'Scale',
        transactionCount: 0,
        description: 'Legal services, attorney fees, and court costs',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'savings',
    name: 'Savings & Investments',
    type: 'expense',
    color: '#00897B',
    icon: 'PiggyBank',
    isExpanded: false,
    description: 'Savings and investment contributions for future financial goals',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'emergency_fund',
        name: 'Emergency Fund',
        type: 'expense',
        color: '#00897B',
        parentId: 'savings',
        icon: 'Shield',
        transactionCount: 0,
        description: 'Emergency fund savings and contributions',
        trackInNetWorth: false,
        isRecurring: false
      },
      {
        id: 'retirement',
        name: 'Retirement',
        type: 'expense',
        color: '#00897B',
        parentId: 'savings',
        icon: 'Clock',
        transactionCount: 0,
        description: 'Retirement account contributions and planning',
        trackInNetWorth: false,
        isRecurring: false
      },
      {
        id: 'investments',
        name: 'Investments',
        type: 'expense',
        color: '#00897B',
        parentId: 'savings',
        icon: 'TrendingUp',
        transactionCount: 0,
        description: 'Investment purchases and portfolio contributions',
        trackInNetWorth: false,
        isRecurring: false
      },
      {
        id: 'real_estate',
        name: 'Real Estate',
        type: 'expense',
        color: '#00897B',
        parentId: 'savings',
        icon: 'Building2',
        transactionCount: 0,
        description: 'Real estate investments and property purchases',
        trackInNetWorth: false,
        isRecurring: false
      }
    ]
  },
  {
    id: 'children',
    name: 'Children',
    type: 'expense',
    color: '#FFA000',
    icon: 'Baby',
    isExpanded: false,
    description: 'Child-related expenses including childcare, supplies, education, and activities',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'childcare',
        name: 'Childcare',
        type: 'expense',
        color: '#FFA000',
        parentId: 'children',
        icon: 'Users',
        transactionCount: 0,
        description: 'Daycare, babysitting, and childcare services',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'baby_supplies',
        name: 'Baby Supplies',
        type: 'expense',
        color: '#FFA000',
        parentId: 'children',
        icon: 'Milk',
        transactionCount: 0,
        description: 'Baby food, diapers, and infant supplies',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'toys',
        name: 'Toys & Games',
        type: 'expense',
        color: '#FFA000',
        parentId: 'children',
        icon: 'Gamepad2',
        transactionCount: 0,
        description: 'Children\'s toys, games, and entertainment',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'children_education',
        name: 'Education',
        type: 'expense',
        color: '#FFA000',
        parentId: 'children',
        icon: 'GraduationCap',
        transactionCount: 0,
        description: 'Children\'s educational expenses and activities',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'children_activities',
        name: 'Activities',
        type: 'expense',
        color: '#FFA000',
        parentId: 'children',
        icon: 'Puzzle',
        transactionCount: 0,
        description: 'Kids\' sports, camps, and extracurricular activities',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'pets',
    name: 'Pets',
    type: 'expense',
    color: '#8D6E63',
    icon: 'Cat',
    isExpanded: false,
    description: 'Pet care expenses including food, veterinary care, supplies, and grooming',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'pet_food',
        name: 'Pet Food',
        type: 'expense',
        color: '#8D6E63',
        parentId: 'pets',
        icon: 'Bone',
        transactionCount: 0,
        description: 'Pet food and treats',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'vet',
        name: 'Veterinary',
        type: 'expense',
        color: '#8D6E63',
        parentId: 'pets',
        icon: 'Stethoscope',
        transactionCount: 0,
        description: 'Veterinary care and medical treatments for pets',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'pet_supplies',
        name: 'Pet Supplies',
        type: 'expense',
        color: '#8D6E63',
        parentId: 'pets',
        icon: 'ShoppingBag',
        transactionCount: 0,
        description: 'Pet supplies, toys, and accessories',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'grooming',
        name: 'Grooming',
        type: 'expense',
        color: '#8D6E63',
        parentId: 'pets',
        icon: 'Scissors',
        transactionCount: 0,
        description: 'Pet grooming and beauty services',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'gifts_donations',
    name: 'Gifts & Donations',
    type: 'expense',
    color: '#C2185B',
    icon: 'Gift',
    isExpanded: false,
    description: 'Charitable giving and gift expenses for others',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'gifts_given',
        name: 'Gifts Given',
        type: 'expense',
        color: '#C2185B',
        parentId: 'gifts_donations',
        icon: 'Gift',
        transactionCount: 0,
        description: 'Gifts purchased for family, friends, and occasions',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'charity',
        name: 'Charity',
        type: 'expense',
        color: '#C2185B',
        parentId: 'gifts_donations',
        icon: 'Heart',
        transactionCount: 0,
        description: 'Charitable donations and philanthropy',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'donations',
        name: 'Donations',
        type: 'expense',
        color: '#C2185B',
        parentId: 'gifts_donations',
        icon: 'HandHeart',
        transactionCount: 0,
        description: 'Donations to causes and organizations',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'miscellaneous',
    name: 'Miscellaneous',
    type: 'expense',
    color: '#757575',
    icon: 'MoreHorizontal',
    isExpanded: false,
    description: 'Other expenses that don\'t fit into specific categories',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'other',
        name: 'Other',
        type: 'expense',
        color: '#757575',
        parentId: 'miscellaneous',
        icon: 'CircleDot',
        transactionCount: 0,
        description: 'Miscellaneous expenses that don\'t fit other categories',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'income_salary',
    name: 'Salary & Wages',
    type: 'income',
    color: '#43A047',
    icon: 'Briefcase',
    isExpanded: false,
    description: 'Employment income including salary, bonuses, and overtime pay',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'salary',
        name: 'Salary',
        type: 'income',
        color: '#43A047',
        parentId: 'income_salary',
        icon: 'Briefcase',
        transactionCount: 0,
        description: 'Regular employment salary and wages',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'bonus',
        name: 'Bonus',
        type: 'income',
        color: '#43A047',
        parentId: 'income_salary',
        icon: 'Award',
        transactionCount: 0,
        description: 'Work bonuses and performance incentives',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'commission',
        name: 'Commission',
        type: 'income',
        color: '#43A047',
        parentId: 'income_salary',
        icon: 'TrendingUp',
        transactionCount: 0,
        description: 'Sales commissions and performance-based income',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'overtime',
        name: 'Overtime',
        type: 'income',
        color: '#43A047',
        parentId: 'income_salary',
        icon: 'Clock',
        transactionCount: 0,
        description: 'Overtime pay and extra hours worked',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'income_business',
    name: 'Business',
    type: 'income',
    color: '#1E88E5',
    icon: 'Building',
    isExpanded: false,
    description: 'Business and self-employment income from various sources',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'business_income',
        name: 'Business Income',
        type: 'income',
        color: '#1E88E5',
        parentId: 'income_business',
        icon: 'Building',
        transactionCount: 0,
        description: 'Income from business operations and ventures',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'freelance',
        name: 'Freelance',
        type: 'income',
        color: '#1E88E5',
        parentId: 'income_business',
        icon: 'Laptop',
        transactionCount: 0,
        description: 'Freelance work and contract income',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'consulting',
        name: 'Consulting',
        type: 'income',
        color: '#1E88E5',
        parentId: 'income_business',
        icon: 'Users',
        transactionCount: 0,
        description: 'Consulting fees and advisory income',
        trackInNetWorth: true,
        isRecurring: true
      }
    ]
  },
  {
    id: 'income_investments',
    name: 'Investments',
    type: 'income',
    color: '#00ACC1',
    icon: 'TrendingUp',
    isExpanded: false,
    description: 'Investment returns including dividends, capital gains, and rental income',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'dividends',
        name: 'Dividends',
        type: 'income',
        color: '#00ACC1',
        parentId: 'income_investments',
        icon: 'PieChart',
        transactionCount: 0,
        description: 'Stock dividends and investment distributions',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'capital_gains',
        name: 'Capital Gains',
        type: 'income',
        color: '#00ACC1',
        parentId: 'income_investments',
        icon: 'BarChart',
        transactionCount: 0,
        description: 'Profits from selling investments or assets',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'interest_income',
        name: 'Interest',
        type: 'income',
        color: '#00ACC1',
        parentId: 'income_investments',
        icon: 'Percent',
        transactionCount: 0,
        description: 'Interest earned from savings and investments',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'rental',
        name: 'Rental Income',
        type: 'income',
        color: '#00ACC1',
        parentId: 'income_investments',
        icon: 'Home',
        transactionCount: 0,
        description: 'Income from rental properties and real estate',
        trackInNetWorth: true,
        isRecurring: true
      }
    ]
  },
  {
    id: 'income_other',
    name: 'Other Income',
    type: 'income',
    color: '#7CB342',
    icon: 'Plus',
    isExpanded: false,
    description: 'Other income sources including gifts, refunds, and government benefits',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'gifts_received',
        name: 'Gifts Received',
        type: 'income',
        color: '#7CB342',
        parentId: 'income_other',
        icon: 'Gift',
        transactionCount: 0,
        description: 'Money received as gifts from others',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'tax_refund',
        name: 'Tax Refund',
        type: 'income',
        color: '#7CB342',
        parentId: 'income_other',
        icon: 'FileText',
        transactionCount: 0,
        description: 'Tax refunds and government rebates',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'reimbursement',
        name: 'Reimbursement',
        type: 'income',
        color: '#7CB342',
        parentId: 'income_other',
        icon: 'RefreshCw',
        transactionCount: 0,
        description: 'Expense reimbursements from employers or others',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'government',
        name: 'Government Benefits',
        type: 'income',
        color: '#7CB342',
        parentId: 'income_other',
        icon: 'Building',
        transactionCount: 0,
        description: 'Government benefits and assistance payments',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'loan_reimbursement',
        name: 'Loan Reimbursement Received',
        type: 'income',
        color: '#7CB342',
        parentId: 'income_other',
        icon: 'ArrowDownLeft',
        transactionCount: 0,
        description: 'Money received back from loans you gave to others',
        trackInNetWorth: true,
        isRecurring: false
      },
      {
        id: 'other_income',
        name: 'Other',
        type: 'income',
        color: '#7CB342',
        parentId: 'income_other',
        icon: 'CircleDot',
        transactionCount: 0,
        description: 'Other income sources not specified elsewhere',
        trackInNetWorth: true,
        isRecurring: false
      }
    ]
  },
  {
    id: 'loans',
    name: 'Loans',
    type: 'expense',
    color: '#795548',
    icon: 'FileText',
    isExpanded: false,
    description: 'Loan-related expenses including repayments, interest, and money lent to others',
    trackInNetWorth: true,
    isRecurring: false,
    subcategories: [
      {
        id: 'loan_repayment',
        name: 'Loan Repayment',
        type: 'expense',
        color: '#795548',
        parentId: 'loans',
        icon: 'CreditCard',
        transactionCount: 0,
        description: 'Principal payments on personal and external loans',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'loan_interest',
        name: 'Loan Interest',
        type: 'expense',
        color: '#795548',
        parentId: 'loans',
        icon: 'Percent',
        transactionCount: 0,
        description: 'Interest charges on borrowed money',
        trackInNetWorth: true,
        isRecurring: true
      },
      {
        id: 'money_lent',
        name: 'Money Lent to Others',
        type: 'expense',
        color: '#795548',
        parentId: 'loans',
        icon: 'ArrowUpRight',
        transactionCount: 0,
        description: 'Money lent to family, friends, or others',
        trackInNetWorth: false,
        isRecurring: false
      }
    ]
  }
] as MainCategory[]

export function useDefaultCategories(): MainCategory[] {
  return defaultCategories
}
